var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.theme() || ""
  var m1 = _vm.theme()
  var g0 = _vm.category.length
  var l0 = _vm.store_open
    ? _vm.__map(_vm.shopData, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g1 = _vm.shopData[index].productList.length
        var g2 = g1 > 0 ? _vm.shopData[index].productList.length : null
        return {
          $orig: $orig,
          g1: g1,
          g2: g2,
        }
      })
    : null
  var g3 = _vm.store_open ? _vm.shopData.length == 0 && !_vm.loading : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
        l0: l0,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }